var _line, _line2, _line3, _line4, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 61,
    viewBox: "0 0 36 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 17.0259,
    x2: 16.5,
    y2: 1.02594,
    stroke: "white",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 17.0259,
    x2: 25.5,
    y2: 1.02594,
    stroke: "white",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 60.0259,
    x2: 16.5,
    y2: 44.0259,
    stroke: "white",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 60.0259,
    x2: 25.5,
    y2: 44.0259,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96395 29.742C2.96395 40.401 10.3079 48.612 21.6809 48.612C28.1579 48.612 32.7989 45.909 35.9099 42.747L32.4419 38.004C29.6879 40.707 25.8119 42.594 21.9359 42.594C14.0819 42.594 9.74695 36.423 9.74695 29.64C9.74695 22.959 13.9289 17.196 21.8849 17.196C25.4039 17.196 29.2289 18.828 31.7789 21.021L34.9409 16.125C31.4219 12.708 26.3219 11.178 21.5789 11.178C10.6649 11.178 2.96395 19.236 2.96395 29.742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCent);
export default __webpack_public_path__ + "static/media/logo-cent.28b0a63fbbf42baabfa2581101d5aa04.svg";
export { ForwardRef as ReactComponent };